export default __webpack_public_path__ + "static/news-sec-d06e3084f9fc655a6cdfd243ec7a876b.jpg";